// extracted by mini-css-extract-plugin
export var front = "item-module--front--befe3";
export var image = "item-module--image--7a4bd";
export var subtitle = "item-module--subtitle--6f116";
export var title = "item-module--title--db437";
export var wrapper = "item-module--wrapper--9a38c";